import { useMutation, useQueryClient } from "react-query";
import { endpoints } from "utils/endpoints";
import http from "utils/http";

const checkoutAsGuest = (postData) => {
  return http().post(endpoints.quotes.checkoutAsGuest, postData)
};

export function usePostCheckoutAsGuest() {
  const queryClient = useQueryClient();
  return useMutation(checkoutAsGuest, {
    onSuccess: () => {
      queryClient.invalidateQueries(["placeOrder"]);
    },
    onError: (errorData) => {
      const errorMessage = errorData?.error?.message || errorData?.message;
      alert(errorMessage);
    },
  });
}
